import styled from "styled-components";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useAlly } from "../../../context/ally";
import m, { desktop } from "../../../styles/molanturTheme";
import { Avatar, Card, Label } from "../ui";

// Perfil del aliado. Solo datos que le sirven a él: sin ids de la base ni comisión (los aliados
// trabajan con precio especial, no con comisión).
export default function Info() {
    const { allyInfo } = useAlly()

    return (
        <Main>
            <Label>Perfil</Label>
            <h1>{allyInfo.name}</h1>
            <Card $pad={18}>
                <div className="who">
                    <Avatar name={allyInfo.name || ''} size={48} />
                    <div>
                        <strong>{allyInfo.name}</strong>
                        <span>Aliado de {allyInfo.agency_name}</span>
                    </div>
                </div>
                <dl>
                    <div>
                        <dt>Email</dt>
                        <dd>{allyInfo.email}</dd>
                    </div>
                    <div>
                        <dt>Aliado desde</dt>
                        <dd>{allyInfo.created_at && format(new Date(allyInfo.created_at), "d 'de' MMMM yyyy", { locale: es })}</dd>
                    </div>
                </dl>
            </Card>
        </Main>
    )
}

const Main = styled.div`
    max-width: 560px;
    h1 {
        margin: 4px 0 18px;
        font-family: ${m.font.display};
        font-weight: 600;
        font-size: 26px;
        line-height: 1.1;
        color: ${m.color.ink};
    }
    .who {
        display: flex;
        align-items: center;
        gap: 12px;
        padding-bottom: 14px;
        border-bottom: 1px solid ${m.color.line};
        strong {
            display: block;
            font-weight: 600;
        }
        span {
            font-size: 13px;
            color: ${m.color.inkFaint};
        }
    }
    dl {
        margin: 0;
        > div {
            display: flex;
            justify-content: space-between;
            gap: 14px;
            padding: 12px 0;
            border-bottom: 1px solid ${m.color.line};
            &:last-child {
                border-bottom: none;
                padding-bottom: 0;
            }
        }
    }
    dt {
        font-size: 14px;
        color: ${m.color.inkSoft};
    }
    dd {
        margin: 0;
        min-width: 0;
        text-align: right;
        font-size: 14px;
        font-weight: 600;
        overflow-wrap: anywhere;
    }
    ${desktop} {
        h1 { font-size: 38px; }
    }
`
